module.exports = __webpack_public_path__ + "0e9eafdf1dfd1f95b096d49169fde801.png";